import { Toast } from 'antd-mobile';
import {
  crazyBuilderInfo,
  crazyBuilderCurrentInfo,
  crazyBuilderBuild,
  crazyBuilderOpenSurpriseBag,
  crazyBuilderRank,
  crazyBuilderReceiveHammerAward,
  crazyBuilderPublish,
  crazyBuilderFriendList,
  crazyBuilderDreamTownInfo,
} from '@/services/activity';
// import { MockInfoData, MockCurrentInfoData, MockLuckyResult, MockRankList, MockRewards } from '../mock';

export default {
  namespace: 'activityCrazyBuilder',
  state: {
    endTime: 0,
    musicUrl: '',
    title: '',
    titleUrl: '',
    rules: '',
    ranks: [],
    selfInfo: {},
    receiveRewards: [],
    lastId: '',
    status: 0,
    days: {},
    nowDay: '',
    isMore: false,
    autoShowRules: 0, // 是否自动展示弹窗规则
    headAvatarClickable: 0,
    surpriseBagCount: 0,
    floorRewards: [],
    dailyRewards: [],
    totalRewards: [],
    buildCountList: [],
    countDownUrl: '',
    hammerValue: 0, // 送多少金币的礼物可得一个锤子
    retainHammerCount: 0, // 可建造数
    usedHammerCount: 0, // 已建造数
    roomId: '', // 跳转房间id
    userInfo: {}, // 用户竣工时自己的头像和名字
    builderKingInfo: {}, // king用户信息
    hammerValueConfig: [],
    shareFlag: 0, // 分享状态
    firstShareHammerNum: 0, // 首次分享可得锤子数
    firstShareThreshold: 0, // 首次分享门槛楼层数
    showSecondSharePopup: false, // 是否展示第二次分享弹窗
    secondShareHammerValue: 0, // 第二次分享可得锤子数
    addLoveValue: 0, // 爱心值
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        endTime: payload.countDown || 0,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        status: payload.status || 0,
        autoShowRules: payload.autoShowRules || 0,
        headAvatarClickable: payload.headAvatarClickable || 0,
        floorRewards: payload.floorRewards || [],
        totalRewards: payload.totalRewards || [],
        dailyRewards: payload.dailyRewards || [],
        countDownUrl: payload.countDownUrl || '',
        buildCountList: payload.buildCountList || [],
        builderKingInfo: payload.builderKingInfo || {},
      };
    },
    updateCurrentInfo(state, { payload }) {
      console.log('payload', payload);
      return {
        ...state,
        hammerValue: payload.hammerValue || '',
        retainHammerCount: payload.retainHammerCount || 0,
        usedHammerCount: payload.usedHammerCount || 0,
        surpriseBagCount: payload.surpriseBagCount || 0,
        roomId: payload.roomId || '', // 跳转房间id
        userInfo: payload.userInfo || {},
        hammerValueConfig: payload.hammerValueConfig || {},
        shareFlag: payload.shareFlag || 0,
        firstShareHammerNum: payload.firstShareHammerNum || 0,
        firstShareThreshold: payload.firstShareThreshold || 0,
        showSecondSharePopup: payload.showSecondSharePopup || false,
        secondShareHammerValue: payload.secondShareHammerValue || 0,
        addLoveValue: payload.addLoveValue || 0,
      };
    },
    updateList(state, { payload }) {
      let list = payload.force ? [] : [...state.ranks];
      let selfInfo = {};
      let lastId = '';
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastId = payload.ranks[payload.ranks.length - 1].userId;
      }
      if (payload.selfInfo && payload.selfInfo.userId) {
        selfInfo = payload.selfInfo;
      }
      return {
        ...state,
        selfInfo: selfInfo,
        ranks: list,
        lastId,
      };
    },
    updateTimeInfo(state, { payload }) {
      return {
        ...state,
        retainHammerCount: payload.retainHammerCount || 0,
        usedHammerCount: payload.usedHammerCount || 0,
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(crazyBuilderInfo, payload);
      // yield put({
      //   type: 'updateInfo',
      //   payload: MockInfoData,
      // });
      // return MockInfoData;
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return data;
    },
    *getCurrentInfo({ payload }, { call, put }) {
      const { error, data } = yield call(crazyBuilderCurrentInfo, payload);
      // yield put({
      //   type: 'updateCurrentInfo',
      //   payload: MockCurrentInfoData,
      // });
      // return MockCurrentInfoData;
      if (error || !data) {
        yield put({
          type: 'updateCurrentInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateCurrentInfo',
        payload: data,
      });
      return data;
    },
    *getList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.activityCrazyBuilder);
      const { error, data } = yield call(crazyBuilderRank, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      // yield put({
      //   type: 'updateList',
      //   payload: { ...MockRankList, force: payload.force },
      // });
      // return true;
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *clearList({ payload }, { call, put }) {
      yield put({
        type: 'updateList',
        payload: { force: true },
      });
    },
    *crazyBuilderBuild({ payload }, { call, put }) {
      const { error, data } = yield call(crazyBuilderBuild, payload);
      // yield put({
      //   type: 'updateTimeInfo',
      //   payload: MockRewards,
      // });
      // return {
      //   success: true,
      //   data: MockRewards,
      // };
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateTimeInfo',
        payload: data,
      });
      return {
        success: true,
        data: data,
      };
    },
    *crazyBuilderOpenSurpriseBag({ payload }, { call }) {
      const { error, data } = yield call(crazyBuilderOpenSurpriseBag, payload);
      // return {
      //   success: true,
      //   data: MockLuckyResult,
      // };
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      return {
        success: true,
        data: data,
      };
    },
    *receiveHammerAward({ payload }, { call, put }) {
      const { error, data } = yield call(crazyBuilderReceiveHammerAward, payload);
      if (error || !data) {
        Toast.show({
          content: error,
        });
        return false;
      }
      return {
        success: true,
        data: data,
      };
    },
    *crazyBuilderPublish({ payload }, { call, put }) {
      const response = yield call(crazyBuilderPublish, payload);
      console.log('response', response);
      if (response.resultDesc === 'success') {
        return {
          success: true,
        };
      } else {
        Toast.show({
          content: response.message,
        });
        return false;
      }
    },
    *crazyBuilderFriendList({ payload }, { call, put }) {
      const { error, data } = yield call(crazyBuilderFriendList, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      return {
        success: true,
        data: data,
      };
    },
    *crazyBuilderDreamTownInfo({ payload }, { call, put }) {
      const { error, data } = yield call(crazyBuilderDreamTownInfo, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      return {
        success: true,
        data: data,
      };
    },
  },
};
